<template>
  <div>
    <div class="Fuell-Toolbar">
      <div class="d-flex  flex-column">
        <h3
          class="Fuell-Toolbar--subtitle"
          v-t="{ path: 'cards_physical_cards_explanation'}"
        ></h3>

        <entity-search-input @search="fetchCards" />
      </div>
    </div>
    <cards-table
      :columns="columns"
      @showCardDetailModal="showCardDetailModal"
    ></cards-table>
    <transactions-export-modal
      v-if="showTransactionDownloadModalFlag"
      :open.sync="showTransactionDownloadModalFlag"
      :extraFilters="downloadDataFilters"
      overlay
      @closeModal="removeHash"
    ></transactions-export-modal>
    <transition name="slither">
      <card-detail-modal
        v-if="showCardDetailModalFlag"
        :open.sync="showCardDetailModalFlag"
        :cardId="cardId"
        @showDownloadModal="showDownloadModal"
        @showTransactionDetail="showTransactionDetail"
        @checkPasscode="toggleCardStatus"
      ></card-detail-modal>
    </transition>
    <transition name="slither">
      <transaction-edit-modal
        v-if="showTransactionEditModalFlag"
        :transactionId.sync="transactionToEditId"
        :open.sync="showTransactionEditModalFlag"
        @showReceiptModal="showReceiptModal"
        @closeModal="handleCloseReceipts"
        @showTransactionModal="showTransactionModal"
      />
    </transition>
    <transaction-receipts-viewer-modal
      :open.sync="showTransactionReceiptModalFlag"
      v-if="showTransactionReceiptModalFlag"
      :transactionId.sync="transactionToShowReceiptId"
      :preloadReceiptId="preloadReceiptId"
    >
    </transaction-receipts-viewer-modal>

  </div>

</template>

<script>
import CardsTable from '../_components/_shared/CardsTable.vue'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'

import _cardMixin from '../_mixins/_cardMixin'
import _transactionsIndexViewShared from '@/modules/transactions/_mixins/_transactionsIndexViewShared'

const TransactionsExportModal = () => import('../../transactions/_components/_shared/TransactionsExportModal.vue')

export default {
  name: 'AllCardsIndex',
  components: {
    CardsTable,
    TransactionsExportModal,
    EntitySearchInput

  },
  mixins: [_cardMixin, _transactionsIndexViewShared],
  data () {
    return {
      downloadDataFilters: {},
      showTransactionDownloadModalFlag: false

    }
  },
  computed: {
    columns () {
      return this.$store.getters['CardsStore/tableColumns']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    }
  },
  methods: {
    removeHash () {
      if (window.location.hash === '#exportHistory') {
        window.location.hash = ''
      }
    },
    showDownloadModal (filters) {
      this.downloadDataFilters = filters
      this.showTransactionDownloadModalFlag = true
    },

    async fetchCards (event) {
      let filters = {}
      if (this.isUser) {
        filters['own'] = true
      }

      if (event) {
        filters['query'] = event
      }
      await this.$store.dispatch('CardsStore/setCardsFilters', filters)
    }
  },
  async created () {
    this.$store.dispatch('CardsStore/clearStore')
    await this.fetchCards()
  }

}
</script>
